import React from 'react'
import SettingLayoutPage from "./SettingLayoutPage"
import {SettingLayoutProvider} from "../context/SettingLayoutContext"

const SettingLayoutContainer = () => {
    return (
        <section className="LeadContainer">
            <SettingLayoutProvider>
                <SettingLayoutPage/>
            </SettingLayoutProvider>
        </section>
    )
}

export default SettingLayoutContainer